// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__W-U-8","location":"Header_location__3-WoS"};